import * as factory from "../../../iawp/src/js/factory";
import cart from './cart'
import './news'
import './jquery.serialscrolling'
import {Fancybox} from '@fancyapps/ui/src/Fancybox/Fancybox'
import InputRange from "./InputRange";
import './productfilters'
import { ajax, error } from "jquery";
new factory.IAInit()

// Cart JS
new cart()

const config = { attributes: true, childList: true, subtree: true };

// NavMenu
const dropdownItem = document.querySelector('.ia-block-dropdown')
const buttonItem = document.querySelector('.menu-item.is-shop')
changeLangDropdown()

function changeLangDropdown() {
    if (window.matchMedia("(max-width: 1230px)").matches) {
        document.querySelector('.ia-block-navigation__content .ia-block-navigation__list').append(buttonItem)
        document.querySelector('.ia-block-navigation__content').append(dropdownItem)
    } else {
        document.querySelector('.section-header .ia-block-menu-cart').prepend(buttonItem)
        document.querySelector('.section-header .sub-item:nth-child(4)').append(dropdownItem)
    } 
}

document.querySelectorAll('.ia-block-dropdown').forEach(dropdown => {
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content')
    )
});


// Shop Titles
document.querySelectorAll('.woocommerce-loop-product__title').forEach(title=>{
    breackTitle(title, title.nextElementSibling)
})

// Open cart when item is added from product list
document.querySelectorAll('.products .product').forEach(product => {
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                mutationList.forEach(mutation => {
                    mutation.addedNodes.forEach(node=>{
                        if(node.className.includes('added_to_cart')){
                            document.querySelector('.is-cart.menu-item').click()
                            node.remove()
                        }
                    })
                })
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(product, config);
})

if(document.querySelector('.quantity')){
    document.querySelectorAll('.quantity').forEach(button=>{
        addQuantityButton(button)
    })
}
if(document.querySelector('.woocommerce-cart-form')){
    document.querySelectorAll('.woocommerce').forEach(block => {
        const callbackButton = (mutationList, observer) => {
            let bool = false;
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    mutationList.forEach(mutation => {
                        mutation.addedNodes.forEach(node=>{
                            if(node.className.includes('woocommerce-cart-form') && !bool){
                                bool = true
                                document.querySelectorAll('.quantity').forEach(button=>{
                                    addQuantityButton(button)
                                })
                            }
                        })
                    })
                }
            }
        };
        const observerButton = new MutationObserver(callbackButton);
        observerButton.observe(block, config);
    })
}

// Bottle Scroll
let d, e, y, yAbs, f, g, windowHeight, imageOffset
if(document.querySelector('h1.product_title')){
    // Update layout of summary
    breackTitle(document.querySelector('h1.product_title'), document.querySelector('h1.product_title'))
    if(!!document.querySelector('.woocommerce-tabs.wc-tabs-wrapper')){   
        console.log('ok');
        d = document.querySelector('.woocommerce-tabs').offsetHeight
        e = document.querySelector('.product .woocommerce-product-gallery__image').offsetHeight
        y = document.querySelector('.woocommerce-tabs').offsetTop + document.querySelector('.woocommerce-tabs').offsetHeight
        yAbs = document.querySelector('.woocommerce-tabs').getBoundingClientRect().top + window.scrollY + document.querySelector('.woocommerce-tabs').offsetHeight
        f = (d - e)/2
        g = y - f
        windowHeight = window.innerHeight
        imageOffset = document.querySelector('.product .woocommerce-product-gallery').offsetTop + e
        window.onscroll = function() {
            const windowBottom = document.documentElement.scrollTop + windowHeight
            imageOffset = document.querySelector('.product .woocommerce-product-gallery').offsetTop + e
            if (Math.abs(imageOffset) >=  g && !matchMedia('(max-width: 1024px)').matches) {
                document.querySelector('.product .woocommerce-product-gallery').setAttribute('style', 'position:relative !important;top:' + (y - e - f) + 'px;');
            }
            if(windowBottom < yAbs ) {
                document.querySelector('.product .woocommerce-product-gallery').removeAttribute('style');
            }
        };
    }else{
        document.querySelector('div.product').classList.add('no-sticky');
    }

    document.querySelectorAll('.product .woocommerce-product-gallery__image a').forEach(imageLink => {
        imageLink.setAttribute('data-fancybox', '')
        Fancybox.bind('[data-fancybox]', {})
    })
}

function breackTitle(title, before){
    const wineTypeArray = ['Auxerrois', 'Bien Arrosé', 'Chardonnay', 'Crémant', 'Crémant', 'Elbling', 'Gewürztraminer', 'Pinot Blanc', 'Pinot Gris', 'Pinot Noir', 'Pinot Noir SF', 'Riesling', 'Riesling SF','Rivaner', 'Vin de Paille', 'Straw wine', 'Tout-Nü', 'Le 8', 'Late Harvest']
    let isInArray = false;
    let i = 0;
    let wine = '';
    let hasSF = (title.textContent.split('SF').length>1)?' SF':'';
    while(!isInArray && i < 4){
        wine = wine + title.textContent.split(' ')[i];
        if(wineTypeArray.includes(wine)){
            isInArray = true
            const subTitle = title.textContent.split(wine)[1]
            const desciption = document.createElement('p')
            title.textContent = title.textContent.replace(subTitle, '') + hasSF
            desciption.classList.add('woocommerce-loop-product__description')
            desciption.textContent = (hasSF !== '')?subTitle.split('SF')[1]:subTitle.split('SF')[0]
            title.parentElement.insertBefore(desciption, before)
        }else {
            wine = wine + ' '
        }
        i = i+1
    }
    if(!!document.querySelector('.product-type-simple')){
        if(!!document.querySelector('.woocommerce-loop-product__description')){
            if(document.querySelector('.woocommerce-loop-product__description').textContent.split('Magnum').length > 1){
                document.querySelector('.woocommerce-loop-product__description').innerHTML = document.querySelector('.woocommerce-loop-product__description').textContent.split('Magnum')[0] + '<br> Magnum'
            }
        }
    }
}
function changeBigQuoteTextColor() {
    if (!!document.querySelector('.wp-block-quote.is-style-big-quote')) {
        document.querySelectorAll('.wp-block-quote.is-style-big-quote').forEach(block => {
            let parentElementWithBackgroundColor = block.closest('.has-background')
            if (parentElementWithBackgroundColor !== null) {
                let textColorClass = parentElementWithBackgroundColor.classList.value.split(' ').filter((elClassName, idx) => /has-color-(\d+)-background-color/.test(elClassName)).join('').replace('-background', '')

                block.querySelectorAll('p').forEach(item => {
                    item.classList.remove(
                        'has-text-color',
                        'has-color-1-color',
                        'has-color-2-color',
                        'has-color-3-color',
                        'has-color-4-color',
                        'has-color-5-color',
                        'has-color-6-color',
                        'has-color-7-color'
                    )
                    item.classList.add('has-text-color', textColorClass)
                })
            }
        })
    }

    if (!!document.querySelector('.wp-block-quote.is-style-large-quote')) {
        document.querySelectorAll('.wp-block-quote.is-style-large-quote').forEach(block => {
            let parentElementWithBackgroundColor = block.closest('.has-background')
            if (parentElementWithBackgroundColor !== null) {
                let textColorClass = parentElementWithBackgroundColor.classList.value.split(' ').filter((elClassName, idx) => /has-color-(\d+)-background-color/.test(elClassName)).join('').replace('-background', '')

                block.querySelectorAll('p').forEach(item => {
                    item.classList.remove(
                        'has-text-color',
                        'has-color-1-color',
                        'has-color-2-color',
                        'has-color-3-color',
                        'has-color-4-color',
                        'has-color-5-color',
                        'has-color-6-color',
                        'has-color-7-color'
                    )
                    item.classList.add('has-text-color', textColorClass)
                })
            }
        })
    }
}
changeBigQuoteTextColor()

// Swiper custom list
document.querySelectorAll('.woocommerce.is-style-swiper').forEach(list=>{
    const swiperWrapper = list.querySelector('.products');
    swiperWrapper.classList.add('swiper-wrapper')
    list.querySelectorAll('.product').forEach(slides=>{
        slides.classList.add('swiper-slide')
    })
    const swiper = new factory.IASwiper(list, {
        autoplay: false,
        watchSlidesProgress: true,
        slidesPerView: 1,
        spaceBetween: 0,
        activeIndex:true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                width: 250,
                spaceBetween: 75,
            }
        },
        pagination: {
            el: list.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: list.querySelector('.swiper-button-next'),
            prevEl: list.querySelector('.swiper-button-prev'),
        },
    })

})

if (!!document.querySelector('.ia-block-history .swiper-container')) {
    let swiperImage 
    let swiperText 
    document.querySelectorAll('.ia-block-history .swiper-container').forEach(block => {
        if(block.classList.contains('no-swipe')) {
            swiperImage = new factory.IASwiper(block, {
                autoplay: false,
                watchSlidesProgress: true,
                autoHeight: false,
                itemPerSlide: 1,
                allowTouchMove: false,
                allowSlidePrev: false,
                allowSlideNext: false,
            })
            return swiperImage
        } 
        if(block.classList.contains('active-swipe')) {
            swiperText = new factory.IASwiper(block, {
                autoplay: false,
                watchSlidesProgress: true,
                autoHeight: false,
                itemPerSlide: 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "bullets",
                    renderBullet: function (index, className) {
                      let yearBullet = this.slides[index].querySelector('.content > p.has-color-3-color.has-text-color').textContent; 
                      return '<span class="' + className + '"><span class="ia-block-history__pagination-label">' + yearBullet + "</span></span>";
                    }
                },
                navigation: {
                    nextEl: block.parentElement.nextElementSibling.querySelector('.swiper-button-next'),
                    prevEl: block.parentElement.nextElementSibling.querySelector('.swiper-button-prev'),
                },
            })
            return swiperText
        }
    })
    swiperText.instance.on('slideChange', function (e) {
        swiperImage.instance.slideTo(e.activeIndex)
    });
}


function addQuantityButton(button){
    const buttonLess = document.createElement('button')
    buttonLess.setAttribute('onclick', "this.parentNode.querySelector('input[type=number]').stepDown()")
    buttonLess.setAttribute('type', 'button')
    const buttonMore = document.createElement('button')
    buttonMore.setAttribute('onclick', "this.parentNode.querySelector('input[type=number]').stepUp()")
    buttonMore.setAttribute('type', 'button')
    button.insertBefore(buttonLess, button.querySelector('.qty'))
    button.append(buttonMore)

    if((document.querySelector('button[name="update_cart"]'))){
        buttonLess.addEventListener('click', function(){
            document.querySelector('button[name="update_cart"]').disabled = false
        })
        buttonMore.addEventListener('click', function(){
            document.querySelector('button[name="update_cart"]').disabled = false
        })
    }
}

if(matchMedia('(max-width: 1024px)').matches){
    document.querySelector('.ia-block-dropdown-options a').addEventListener('click', function(e){
        e.target.classList.add('active');
    })
}

window.onresize = function() {
    changeLangDropdown()

    if(document.querySelector('h1.product_title')){
        const windowBottom = document.documentElement.scrollTop + windowHeight
        d = document.querySelector('.woocommerce-tabs').offsetHeight
        e = document.querySelector('.product .woocommerce-product-gallery__image').offsetHeight
        y = document.querySelector('.woocommerce-tabs').offsetTop + document.querySelector('.woocommerce-tabs').offsetHeight
        yAbs = document.querySelector('.woocommerce-tabs').getBoundingClientRect().top + window.scrollY + document.querySelector('.woocommerce-tabs').offsetHeight
        f = (d - e)/2
        g = y - f
        windowHeight = window.innerHeight
        imageOffset = document.querySelector('.product .woocommerce-product-gallery').offsetTop + e

        if(matchMedia('(max-width: 1024px)').matches){
            document.querySelector('.product .woocommerce-product-gallery').removeAttribute('style');
        }
        
        if(matchMedia('(max-width: 1024px)').matches){
            document.querySelector('.ia-block-dropdown-options a').addEventListener('click', function(e){
                e.target.classList.add('active');
            })
        }

        if (Math.abs(imageOffset) >=  g && !matchMedia('(max-width: 1024px)').matches) {
            document.querySelector('.product .woocommerce-product-gallery').setAttribute('style', 'position:relative !important;top:' + (y - e - f) + 'px;');
        }
    }
} 

if(!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {},
            messagesIdClass: '.' + form.querySelector('input[name="action"]').value
        })
    })
}
if(!!document.querySelector('.ia-block-footer-newsletter-form')) {
    document.querySelectorAll('.ia-block-footer-newsletter-form').forEach(form => {
        new factory.IAForm(form, true, {
            messagesIdClass: '#' + form.querySelector('input[name="action"]').value
        }).formInside(true)
    })
}

if (!!document.querySelector('input[name="action"][value="contactForm"]')) {
    document.querySelector('.section-default').classList.add('has-color-7-background-color', 'has-background')
}

// Remove empty <p></p> tags that WP/WC adds in this block
if (!!document.querySelector('.ia-block-product-filters')) {
    document.querySelectorAll('.ia-block-product-filters').forEach(block => {
        block.querySelectorAll('p:empty, br').forEach(tag => {
            tag.remove()
        })

        if (!!block.querySelector('.js-ia-block-product-filters-reset')) {
            block.querySelector('.js-ia-block-product-filters-reset').addEventListener('click', btn => {
                block.querySelectorAll('.form-above-input.form-select select').forEach(select => {
                    select.value = ''
                })

                block.querySelector('[name="prix_max"]').value = block.querySelector('[name="prix_max"]').getAttribute('max')
                block.querySelector('[name="prix_min"]').value = block.querySelector('[name="prix_min"]').getAttribute('min')

                block.querySelector('form').dispatchEvent(new Event('submit'))
            })
        }
    })

    document.querySelector('.js-ia-block-product-filters-toggle').addEventListener('click', e => {
        let btn = e.target
        //let block = btn.closest('.ia-block-product-filters')
        let target = block.querySelector('.ia-block-product-filters__inner-container')
        target.classList.toggle('active')
    })
}

if (!!document.querySelector('.ia-block-post-filters')) {
    document.querySelector('.js-ia-block-product-filters-toggle').addEventListener('click', e => {
        let btn = e.target
        let target = document.querySelector('.ia-block-posts-filters__list')
        target.classList.toggle('active')
    })
}

// Initialize input range
if (!!document.querySelector('.input-range')) {
    document.querySelectorAll('.input-range').forEach(input => {
        new InputRange(input)
    })
}

factory.$('.js-serialscrolling').serialscrolling({'offsetTop':-50});


document.querySelectorAll('.related.products .products .product').forEach(product => {
    const productPrice = product.querySelector('.price')
    product.querySelector('.woocommerce-loop-product__title').append(productPrice)
})

// removelogo bio if product is not bio
const stringsBio = ['certifiée'];
const stringOrg = ['organic'];
if (document.querySelector('#tab-additional_information')){
    if(!stringsBio.some(value => document.querySelector('#tab-additional_information').outerHTML.toLocaleLowerCase().includes(value)) && !stringOrg.some(value => document.querySelector('#tab-additional_information').outerHTML.toLocaleLowerCase().includes(value))) {
        document.querySelector('#tab-additional_information').classList.add('hide-logo-bio')
    }
}

// Add custom select styles
document.querySelectorAll('.variations .value > select').forEach(select => {
    let parent = select.parentElement
    parent.classList.add('custom-select')
})

//rewrite instagram description
if(!!document.querySelector('.sbi_bio')) {
    let desc = document.querySelector('.sbi_bio');
    const newDesc = document.querySelector('.sbi_bio').innerHTML.split('/');
    desc.innerHTML = '';

    newDesc.forEach(line => {
        const span = document.createElement('span');
        span.innerText = line;
        desc.appendChild(span);
    });
    
}

if(!!document.querySelector('#place_order')){
    var targetNode = document.getElementById("order_review")
    var configCheckout = { childList: true };
    var callback = function (mutationsList) {
    for (var mutation of mutationsList) {
        if (mutation.type == "childList") {
            document.querySelector('#place_order').addEventListener('click', button => {
                let total = 0;
                document.querySelectorAll('.product-quantity').forEach(product => {
                    let myProduct = product.textContent.split('');
                    total += Number(myProduct[2])
                })
                
                if(total < 24 && document.querySelector('#select2-billing_country-container').textContent != "Luxembourg") {
                    button.preventDefault();
        
                    // ADD AJAX CODE TO DISPLAY ERROR MESSAGE
                    factory.$.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'getQty',
                        },
                        success: function (response) {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            if(!!document.querySelector('.woocommerce-error')){
                                let boolCheck = false;
                                Array.from(document.querySelector('.woocommerce-error').children).forEach(childError => {
                                    if(childError.textContent.trim().includes('must have a minimum of')){
                                        boolCheck = true;
                                    }
                                })
                                if(!boolCheck){
                                    factory.$(response).insertBefore('.woocommerce-form-coupon-toggle')
                                }
                            }else{
                                factory.$(response).insertBefore('.woocommerce-form-coupon-toggle')
                            }
                        }
                    })
                }
            })
        }
    }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, configCheckout);
}